import React, { createContext, useState } from 'react'
import { GrowthContent } from '@mc/api'
import { type CourseTile } from '../types'
import { TrailerModal } from './TrailerModal'

export interface VideoContextProps {
  isModalOpen: boolean
  currentContent: CourseTile | GrowthContent | null
  openVideo: (course: CourseTile | GrowthContent) => void
  closeVideo: () => void
}

export const VideoContext = createContext<VideoContextProps>({
  isModalOpen: false,
  openVideo: () => {},
  closeVideo: () => {},
  currentContent: null,
})

type ProviderProps = {
  children?: React.ReactNode
}

export const VideoModalContextProvider = ({ children }: ProviderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentContent, setCurrentContent] = useState<
    CourseTile | GrowthContent | null
  >(null)

  const openVideo = (course: CourseTile | GrowthContent) => {
    setIsModalOpen(true)
    setCurrentContent(course)
  }

  const closeVideo = () => {
    setIsModalOpen(false)
    setCurrentContent(null)
  }

  return (
    <VideoContext.Provider
      value={{
        isModalOpen,
        currentContent,
        openVideo,
        closeVideo,
      }}
    >
      {children}
      <TrailerModal />
    </VideoContext.Provider>
  )
}
